<template>
  <v-container
    fluid
    fill-height
    class="grey lighten-4"
  >
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        lg="4"
      >
        <v-card
          elevation="10"
          class="py-8"
        >
          <v-row justify="center">
            <v-col
              cols="10"
              sm="8"
              class="text-center"
            >
              <v-img
                src="/img/quats-logo.png"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="11"
              class="text-center"
            >
              <h2 class="error--text">
                {{ $t('common.page_denied_title') }}
              </h2>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="11"
              class="text-center"
            >
              <p style="font-size: 14px;">
                {{ $t('common.page_denied_desc', { pageName: page_name[`name_${$i18n.locale}`], groupName: group_name[`name_${$i18n.locale}`]}) }}
              </p>
            </v-col>
          </v-row>
          <v-row
            justify="center"
            class="mt-4"
          >
            <v-col
              cols="11"
              sm="6"
              class="text-center"
            >
              <v-btn
                block
                style="color: white;"
                color="primary"
                :to="{name: 'Home'}"
              >
                {{ $t('navigation_list.home_page') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="11"
              sm="6"
              class="text-center"
            >
              <v-btn
                block
                outlined
                small
                @click="back"
              >
                <v-icon class="mr-2">
                  mdi-arrow-left
                </v-icon>
                {{ $t('navigation_list.back') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

export default {
  data () {
    return {
      page_name: {
        name_en: null,
        name_jp: null,
      },
      group_name: {
        name_en: null,
        name_jp: null,
      }
    }
  },
  created() {
    const query = Object.assign({}, this.$route.query)
    this.page_name.name_en = query.page_en
    this.page_name.name_jp = query.page_jp
    if(!this.page_name.name_en) {
      this.page_name.name_en = this.page_name.name_jp
    }

    this.group_name.name_en = query.group_en
    this.group_name.name_jp = query.group_jp
    if(!this.group_name.name_en) {
      this.group_name.name_en = this.group_name.name_jp
    }
  },
  methods: {
    back() {
      // go back once is not working
      window.history.go(-2)
    }
  }
}
</script>
